import {
  AccessibilityHelp,
  Alignment,
  Autosave,
  BalloonToolbar,
  Bold,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  GeneralHtmlSupport,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  Paragraph,
  PasteFromOffice,
  SelectAll,
  Underline,
  Undo,
  type EditorConfig,
} from 'ckeditor5';

import translations from 'ckeditor5/translations/it.js';

export const DEFAULT_FONT = 'Arial, Helvetica, sans-serif';

export const EDITOR_CONFIG: EditorConfig = {
  toolbar: {
    items: [
      'undo',
      'redo',
      '|',
      'bold',
      'italic',
      'underline',
      '|',
      'fontFamily',
      'fontSize',
      'fontColor',
      'fontBackgroundColor',
      '|',
      'alignment',
      '|',
      'bulletedList',
      'numberedList',
      'outdent',
      'indent',
      '|',
      'link',
    ],
    shouldNotGroupWhenFull: false,
  },

  plugins: [
    AccessibilityHelp,
    Alignment,
    Autosave,
    BalloonToolbar,
    Bold,
    Essentials,
    FontBackgroundColor,
    FontColor,
    FontSize,
    FontFamily,

    /** (molto pesante) */
    GeneralHtmlSupport,

    Indent,
    IndentBlock,
    Italic,
    Link,
    List,
    Paragraph,
    PasteFromOffice,
    SelectAll,
    Underline,
    Undo,
  ],

  balloonToolbar: ['bold', 'italic', '|', 'link', '|', 'bulletedList', 'numberedList'],

  fontSize: {
    options: [10, 12, 14, 'default', 18, 20, 22],
    supportAllValues: true,
  },

  /**  molto pesante */
  htmlSupport: {
    allow: [
      {
        name: /^.*$/,
        styles: true,
        attributes: true,
        classes: true,
      },
    ],
  },

  language: 'it',

  link: {
    addTargetToExternalLinks: true,
    defaultProtocol: 'https://',
    decorators: {
      toggleDownloadable: {
        mode: 'manual',
        label: 'Downloadable',
        attributes: {
          download: 'file',
        },
      },
    },
  },

  placeholder: 'Inserire o incollare qui il proprio contenuto.',
  translations: [translations],

  fontFamily: {
    options: ['default', DEFAULT_FONT],
    supportAllValues: true,
  },
};
